import React from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, useMediaQuery, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { IconCaretRightFilled } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../resources/strings/StringKeys';
import CustomPagination from '../../../components/pagination/CustomPagination';

const InventoryOrdersTable = ({ orders, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage  }) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:600px)');
  const { t } = useTranslation();

  const paginatedOrders = rowsPerPage > 0 
    ? orders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    : orders;

  return (
    <>
      <TableContainer style={{ overflowX: 'auto' }}>
        <Table aria-label="orders-table">
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold' }}>
                {t(StringKeys.ORDER)}
              </TableCell>
              {!isMobile && (
                <>
                  <TableCell style={{ fontWeight: 'bold' }}>
                    {t(StringKeys.SUPPLIER)}
                  </TableCell>
                  <TableCell style={{ fontWeight: 'bold' }}>
                    {t(StringKeys.STATUS)}
                  </TableCell>
                  <TableCell style={{ fontWeight: 'bold' }}>
                    {t(StringKeys.ORDER_DATE)}
                  </TableCell>
                </>
              )}
              {isMobile && <TableCell style={{ textAlign: "center" }}></TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedOrders.map((order, index) => (
              <TableRow
                key={index}
                hover
                onClick={() => {
                  if (!isMobile) {
                    navigate(`/inventory-orders/${order.id}`, { state: { order } });
                  }
                }}
                style={{ cursor: !isMobile ? 'pointer' : 'default' }}
              >
                <TableCell>{order.id}</TableCell>
                {!isMobile && (
                  <>
                    <TableCell>{order.supplier}</TableCell>
                    <TableCell>{t(order.status)}</TableCell>
                    <TableCell>{new Date(order.order_date.seconds * 1000).toLocaleDateString()}</TableCell>
                  </>
                )}
                {isMobile && (
                  <TableCell style={{ textAlign:"end" }}>
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/inventory-orders/${order.id}`, { state: { order } });
                      }}
                    >
                      <IconCaretRightFilled />
                    </IconButton>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      
      <CustomPagination
        rowsPerPageOptions={[10, 25, 100, { label: 'All', value: -1 }]}
        component="div"
        count={orders.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default InventoryOrdersTable;
